module.exports = __webpack_public_path__ + "media/dorobek/assets/images/icons/Third_criterium-cbdc2c6ea7eaedb514cd1e8f96497689.svg";